import { makeStyles } from '@material-ui/core/styles';

export const useAuthorizeThirdStyles = makeStyles(() => ({
  title: {
    fontSize: 16,
    fontWeight: 600,
    textAlign: 'center',
  },
  container: {
    borderTop: (props) => (props.mobile ? '' : '1px solid #6A148E'),
    backgroundColor: (props) => (props.mobile ? '' : '#F1F1F1'),
    display: 'flex',
    flexDirection: 'column',
    marginTop: '20px',
    width: '100%',
    padding: (props) => (props.mobile ? '' : '30px 70px'),
  },
  button: {
    maxWidth: 200,
    margin: '0 auto',
  },
  loader: {
    height: 80,
    width: 80,
  },
  divButtonLoading: {
    margin: 'auto',
  },
}));

export const useAuthorizeCheckboxStyles = makeStyles((theme) => ({
  text: {
    fontSize: '14px',
    color: '#666666',
    '& a': {
      textDecoration: 'underline',
      fontWeight: '600',
      color: '#464646',
    },
  },
  checkbox: {
    color: `${theme.palette.primary.main}`,
    '&.MuiCheckbox-colorSecondary.Mui-checked': {
      color: `${theme.palette.primary.main}`,
    },
    '&.MuiCheckbox-colorSecondary.Mui-checked.Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.26)',
    },
  },
}));
